import React from "react";
import Footer from "../Components/Footer";
import "../styles/blog.css";

export default function Blogs() {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "60vh",
          backgroundColor: "#292E36",
          alignItems: "center",
        }}
      >
        {/* <div className="blog-div">
          <p style={{ color: "#fff", fontWeight: 700, fontSize: 60 }}>
            Blog Page
          </p>
        </div> */}
        <div>
          <div className="chat-container">
            <div className="chat-header">AI Robot Chat</div>
            <div className="chat-messages" id="chatMessages"></div>
            <div className="input-area">
              <input
                type="text"
                id="chatInput"
                placeholder="Type your message..."
              />
              <button onClick="sendMessage()">Send</button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
